import React from "react";
import { SocialMediaIconProps } from "./socialMedia.types";

// ============================================
// TwitterX Icon Variants
// ============================================

const TwitterXOriginal = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="X" role="img" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
  </svg>
);

const TwitterXOutlined = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.2998 3.17667L10.1534 13.1892L3.44497 20.9767H4.93127L10.8098 14.148L15.4842 20.9767H21.0998L13.9395 10.5168L20.2581 3.17667H18.7763L13.2821 9.55524L8.91543 3.17667H3.2998ZM5.0746 4.11351H8.42334L19.325 20.0398H15.9763L5.0746 4.11351Z" fill="currentColor" stroke="currentColor" strokeWidth="0.988889"/>
  </svg>
);

const TwitterXRounded = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM5.83105 6.05957L10.3467 12.6562L5.7959 17.9404H7.86914L8 17.7891L11.2637 13.9961L13.834 17.751L13.9648 17.9404H18.4961L13.79 11.0654L18.1006 6.05957H16.0303L15.8994 6.21094L12.8721 9.72363L10.4932 6.24902L10.3623 6.05957H5.83105ZM9.59766 7.5127L15.7412 16.4873H14.7295L8.58594 7.5127H9.59766Z" fill="currentColor"/>
  </svg>
);

const TwitterXSquared = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.2695 1.5C21.0536 1.50016 22.4998 2.9464 22.5 4.73047V19.2695C22.4998 21.0536 21.0536 22.4998 19.2695 22.5H4.73047C2.9464 22.4998 1.50016 21.0536 1.5 19.2695V4.73047C1.50016 2.9464 2.9464 1.50016 4.73047 1.5H19.2695ZM5.5 5.79199L10.2354 12.7119L5.50195 18.207H7.34668L11.0518 13.9033L13.9971 18.207H18.5L13.5596 10.9912L18.0371 5.79199H16.1953L16.0986 5.90625L12.7441 9.79883L10.0029 5.79199H5.5ZM9.33203 7.06445L16.0889 16.9346H14.668L7.91113 7.06445H9.33203Z" fill="currentColor"/>
  </svg>
);

export default function TwitterX({ variant = "original", ...props }: SocialMediaIconProps) {
  switch (variant) {
    case "outlined": return <TwitterXOutlined {...props} />;
    case "rounded": return <TwitterXRounded {...props} />;
    case "squared": return <TwitterXSquared {...props} />;
    case "original":
    default: return <TwitterXOriginal {...props} />;
  }
}
